import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (

      <div className="container py-6">
        <div className="ant-card ant-card-bordered">
          <div className="ant-card-body">
            <form>
              <p className="has-text-primary is-size-7">(*) is required field.</p>
              <div className="field"><label for="tokenType" className="label">Token Type<sup
                className="has-text-danger">*</sup></label>
                <div className="control"><select name="tokenType" id="tokenType" className="input">
                  <option value="standard">Standard Token</option>
                  <option value="liquidity">Liquidity Generator Token</option>
                  <option value="baby">Baby Token</option>
                  <option value="buyback">Buyback Baby Token</option>
                </select>
                  <p className="help is-info"> 0.2 BNB</p>
                </div>
              </div>
              <div className="field"><label for="tokenName" className="label">Name<sup
                className="has-text-danger">*</sup></label>
                <div className="control"><input type="text" className="input" id="tokenName" name="tokenName" placeholder="Ex: Ethereum" maxlength="255" /></div>
              </div>
              <div className="field"><label for="tokenSymbol" className="label">Symbol<sup
                className="has-text-danger">*</sup></label>
                <div className="control"><input type="text" className="input" id="tokenSymbol" name="tokenSymbol" placeholder="Ex: ETH" maxlength="255" /></div>
              </div>
              <div className="field"><label for="tokenDecimals" className="label">Decimals<sup
                className="has-text-danger">*</sup></label>
                <div className="control"><input type="number" className="input" id="tokenDecimals" name="tokenDecimals" placeholder="Ex: 18" /></div>
              </div>
              <div className="field"><label for="totalSupply" className="label">Total supply<sup
                className="has-text-danger">*</sup></label>
                <div className="control"><input type="text" className="input" id="totalSupply" name="totalSupply" placeholder="Ex: 100000000000" /></div>
              </div>
              <div className="field"><label className="ant-checkbox-wrapper"><span
                className="ant-checkbox"><input type="checkbox" className="ant-checkbox-input"
                  value="" /><span
                    className="ant-checkbox-inner"></span></span><span>Implement Pink
                      Anti-Bot System?</span></label></div>
              <div className="has-text-centered mt-6 mb-4"><button type="submit" className="ant-btn ant-btn-primary" disabled=""><span>Create
                token</span></button></div>
            </form>
          </div>
        </div>
      </div>

    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
